import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import LanguageContext from "../../i18n/LanguageContext";

class ProductSliderV2 extends Component {
  render() {
    const { t } = this.context;
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div
        className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-115 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center---">
                <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                  {t("gallery.subtitle")}
                </h6>
                <h1 className="section-title">
                  {t("gallery.title")} <br />
                </h1>
              </div>
            </div>
          </div>
          <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
            <div className="col-lg-4">
              <div className="ltn__search-by-place-item">
                <div className="search-by-place-img">

                    <img src={publicUrl + "assets/img/bahce.png"} alt="#" />

                </div>
                <div className="search-by-place-info">
                  <h6>{t("gallery.c1Sub")}</h6>
                  <h4>{t("gallery.c1Title")}</h4>
                  <p>{t("gallery.c1Text")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__search-by-place-item">
                <div className="search-by-place-img">

                    <img src={publicUrl + "assets/img/ic.png"} alt="#" />

                </div>
                <div className="search-by-place-info">
                  <h6>{t("gallery.c2Sub")}</h6>
                  <h4>{t("gallery.c2Title")}</h4>
                  <p>{t("gallery.c2Text")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__search-by-place-item">
                <div className="search-by-place-img">

                    <img src={publicUrl + "assets/img/isitma.png"} alt="#" />

                </div>
                <div className="search-by-place-info">
                  <h6>{t("gallery.c3Sub")}</h6>
                  <h4>{t("gallery.c3Title")}</h4>
                  <p>{t("gallery.c3Text")}</p>
                </div>
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    );
  }
}

ProductSliderV2.contextType = LanguageContext;

export default ProductSliderV2;
